<template>
    <div>
        <div>
            <h3>1、记得让家长转发朋友圈广告！！！</h3>
            2、扫码支付记得备注学生姓名！！！<br>
            3、收到现金记得告诉陆天屹！！！
        </div>
        <div>
            <img style="width: 300px;vertical-align: text-top;" src="@/assets/img/settleSuccess/wc_code2.png" >
        </div>
        <div style="text-align: right">
            <el-button type="primary" @click="handleInvoiceDetail()">确 认</el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Dialog_SettleSuccess",
        methods: {
            handleInvoiceDetail(){
                this.$Win.openModal('Dialog_InvoiceDetail', 760, 800, '合同详情', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            }
        }
    }
</script>

<style scoped>

</style>